export enum ErrorType {
    NONE = 0,
    INFO = 1,
    ERROR = 2,
}



// WEBPACK FOOTER //
// ./src/app/enums/app-error-type.ts